import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./ScheduleTour.css";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import ScheduleTourFormOne from "../../components/schedule_tour/ScheduleTourFormOne";
import ScheduleTourFormTwo from "../../components/schedule_tour/ScheduleTourFormTwo";
import ScheduleTourFormThree from "../../components/schedule_tour/ScheduleTourFormThree";
function ScheduleTour() {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();
  useEffect(() => {
    if (userId) {
    } else {
      navigate("/user-register");
    }
  }, [userId]);

  const location = useLocation();

  const [tourDateTimeExpiry, setExpiry] = useState("");
  const [downPayment, setDownPayment] = useState("");
  const [employeeSalary, setEmployeeSalary] = useState("");
  const [tourDateTime, setTourDateTime] = useState("");
  const [bankContractPdf, setPdf] = useState(null);
  const [index, setIndex] = useState(1);
  const handleBack = () => {
    console.log("back");
    if (index > 1) {
      setIndex(index - 1);
    }
  };

  return (
    <div className="schedule-tour">
      <Link style={{ textDecoration: "none" }} to="/">
        <img src="/img/Logo.svg" className="home-logo" alt="" />
      </Link>

      <div className="container-fluid schedule-tour-container px-0">
        <div className="row px-0 mx-0">
          <div className="col-lg-6 agent-register-form-conatiner d-flex justify-content-center px-0">
            {index > 1 ? (
              <div
                role="button"
                onClick={handleBack}
                className={`make-offer-yes-no-card`}
              >
                Back
              </div>
            ) : (
              <></>
            )}
            <h2 className="agent-register-heading mt-2">Schedule a Tour</h2>

            {index === 1 ? (
              <ScheduleTourFormOne
                props={{ tourDateTimeExpiry, setExpiry, setIndex }}
              />
            ) : index === 2 ? (
              <ScheduleTourFormTwo
                props={{ bankContractPdf, setPdf, setIndex }}
              />
            ) : index === 3 ? (
              <ScheduleTourFormThree
                props={{
                  downPayment,
                  setDownPayment,
                  employeeSalary,
                  setEmployeeSalary,
                  tourDateTime,
                  setTourDateTime,
                  tourDateTimeExpiry,
                  bankContractPdf,
                  setIndex,
                }}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6 text-center d-none d-lg-block">
            <img
              src="/img/schedule_tour.png"
              className="img-fluid schedule-tour-right"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleTour;
